module.exports = __webpack_public_path__ + "static/media/PE.14e66b52.png";